var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"col-12 col-md-3 py-4"},[_c('img',{staticClass:"mw-100",attrs:{"src":'/assets/images/products/' + _vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }